// extracted by mini-css-extract-plugin
export var section = "Navigation-module--section--OxLkT";
export var title = "Navigation-module--title--fphKd";